import { Dialog } from '@mui/material';
import { profileStateYear } from '../../service';
import { useProfile } from '../../components/state/hooks';
import Loader from '../../components/Loader';
import arrowright from '../../static/img/arrowrightwelcomeslide.svg';
import aiImg from '../../static/img/ai-img.svg';
import {
  StyledDialogContent,
  Title,
  Subtitle,
  GetStartedButton,
  JeddSpan,
  WelcomeText,
  TextContainer,
  JeddGroup
} from './OnboardingWelcomeSlideStyle';
import jeddtext from '../../static/img/jeddtext.svg';

//This component is used to display the onboarding welcome slide.

const OnboardingWelcomeSlide = ({
  onNext,
  open = true,
  subtitle = 'Your personalised AI marking assistant',
}) => {
  const { data: profile, isLoadingdata: isLoadingProfile } = useProfile();

  const handleGetStartedButtonClick = () => {
      onNext(); 
  };

  if (isLoadingProfile) {
    return <Loader />;
  }

  return (

    
      <StyledDialogContent>
        <TextContainer>
          <Title>
            <WelcomeText>Welcome to</WelcomeText>

            <JeddGroup>
              <JeddSpan>
                <img src={jeddtext} alt="jeddtext" />
              </JeddSpan>

              <img src={aiImg} alt="ai-img" />
            </JeddGroup>
          </Title>

          <Subtitle>
            {subtitle}
          </Subtitle>
        </TextContainer>

        <GetStartedButton
          variant="contained"
          onClick={handleGetStartedButtonClick}
          endIcon={
            <img
              src={arrowright}
              alt="arrowright"
              style={{ width: '24px', height: '24px' }}
            />
          }
        >
          Get Started
        </GetStartedButton>
      </StyledDialogContent>

  );
};

export default OnboardingWelcomeSlide;